module.exports = __webpack_public_path__ + "static/img/shopping_home.cfd69c00.png";